export { default as Contact } from './Contact';
export { default as Form } from './Form';
export { default as Hero } from './Hero';
export { default as Newsletter } from './Newsletter';
